import { render } from "./Q4Detaillee.vue?vue&type=template&id=0724f0d6"
import script from "./Q4Detaillee.vue?vue&type=script&lang=js"
export * from "./Q4Detaillee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__